<template>
    <div class="bg-white rounded box-shadow p-3">
        <b-modal id="password-attempt" size="lg" title="User Password Attempt" hide-footer>
            <div class="modal-content bg-white rounded box-shadow">
                <b-card>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>SL</th>
                                <th>Description</th>
                                <th>IP Address</th>
                                <th>Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(access_log, index) in access_logs" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ access_log.event }}</td>
                                <td>{{ access_log.ip_address }}</td>
                                <td>{{ customCreatedDate(access_log.created_at) }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <h5 v-if="access_logs.length === 0" class="text-center text-secondary">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import http from "@state/http";
    import moment from "moment";

    export default {
        name: "PasswordAttempt",
        props: ["access_logs"],
        components: {  },
        data() {
            return {

            };
        },

        methods: {
            customCreatedDate(date) {
                return moment(date).format("YYYY-MM-DD, h:mm:ss a");
            },
        },
        mounted() {}
    };
</script>
